// extracted by mini-css-extract-plugin
module.exports = {"block":"ModalBody_block__AS_rC","error":"ModalBody_error__eVHuy","blockTitle":"ModalBody_blockTitle__5myQD","blockDescription":"ModalBody_blockDescription__JcjLH"};